// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__MMKfG","sport":"Tag_sport__QgifN","waveAnimation":"Tag_waveAnimation___KVB6","marquee":"Tag_marquee__fwqI4"};